import type { ReactNode } from 'react';
import { Star, X } from 'lucide-react';
import { DialogDescription, DialogTitle } from '@/components/ui/dialog';

interface Props {
  titulo: ReactNode;
  descricao: ReactNode;
  onClose: () => void;
  controles?: ReactNode;
}

export function NotaPrimeDialogHeader({ titulo, descricao, onClose, controles }: Props) {
  return (
    <div className="relative flex-shrink-0 overflow-hidden bg-gradient-to-br from-brand-vinho via-primary to-brand-borgonha px-5 py-3.5">
      <div aria-hidden className="pointer-events-none absolute -right-10 -top-16 h-36 w-36 rounded-full border border-white/10 bg-white/[0.04]" />
      <div className="relative flex items-start justify-between gap-4">
        <div className="min-w-0">
          <DialogTitle className="flex min-w-0 items-center gap-2 text-white">
            <Star className="h-4 w-4 flex-shrink-0 fill-white/10 text-white/80" />
            <span className="min-w-0 truncate font-display text-[16px] font-bold">{titulo}</span>
          </DialogTitle>
          <DialogDescription className="mt-1 text-[11px] leading-relaxed text-white/70">
            {descricao}
          </DialogDescription>
        </div>
        <div className="flex flex-shrink-0 items-center gap-2">
          {controles}
          <button
            type="button"
            onClick={onClose}
            className="grid h-7 w-7 place-items-center rounded-full border border-white/20 bg-white/10 text-white transition-colors hover:bg-white/20"
            title="Fechar"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
